import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import cn from 'classnames/bind'
import Categories from './Categories'
import SortBy from './SortBy'
import Sidebar from '../Sidebar'
import CollectionIcon from './CollectionIcon'
import ProductIcon from './ProductIcon'
import MobileFiltersMenu from '../MobileFiltersMenu'

/** @param {import('./index').FiltersProps} props */
export default function Filters(props) {
    const {
        categories,
        isCustomStore,
        filters,
        sort,
        tags,
        ownDesignAllowed,
    } = props

    const isMobile = useSelector((state) => state.isMobile)
    const [isOpen, setIsOpen] = useState(false)
    const [content, setContent] = useState(null)

    useEffect(() => {
        if (isOpen) {
            document.documentElement.classList.add('store-menu-active')
        } else {
            document.documentElement.classList.remove('store-menu-active')
        }
    }, [isOpen])

    const toggleMenu = (newContent) => (e) => {
        e.preventDefault()
        setIsOpen(!isOpen)
        setContent(newContent || content)
    }

    const closeMenu = () => setIsOpen(false)

    return (
        <div
            className={cn('filters', 'for-hint', 'clearfix', {
                ['filters_custom-store']: isCustomStore,
            })}
        >
            <If condition={isMobile}>
                <MobileFiltersMenu closeMenu={closeMenu}>
                    <If condition={content === 'sidebar'}>
                        <h2 className={cn('text-center', 'text-white')}>
                            Коллекции
                        </h2>
                        <Sidebar
                            tags={tags}
                            ownDesignAllowed={ownDesignAllowed}
                            filters={filters}
                            isOpen={true}
                            withChildren={true}
                        />
                        <div>
                            <button
                                className="b-btn b-btn_success b-btn_small"
                                onClick={toggleMenu()}
                            >
                                Показать
                            </button>
                        </div>
                    </If>
                    <If condition={content === 'filters'}>
                        <h2 className={cn('text-center', 'text-white')}>
                            Фильтр
                        </h2>
                        <Categories
                            categories={categories}
                            isCustomStore={isCustomStore}
                            filters={filters}
                        />
                        <SortBy sort={sort} isSelect={true} filters={filters} />
                        <div className="text-center">
                            <button
                                className="b-btn b-btn_success b-btn_small"
                                onClick={toggleMenu()}
                            >
                                Показать
                            </button>
                        </div>
                    </If>
                </MobileFiltersMenu>
                <If condition={!isCustomStore}>
                    <div className="col-xs-6 hidden-md hidden-lg text-center filters__item">
                        <a
                            href="#"
                            className="b-btn"
                            onClick={toggleMenu('sidebar')}
                        >
                            <CollectionIcon />
                            Коллекции
                        </a>
                    </div>
                </If>
                <div className="col-xs-6 hidden-md hidden-lg text-center filters__item">
                    <a
                        href="#"
                        className="b-btn"
                        onClick={toggleMenu('filters')}
                    >
                        <ProductIcon />
                        Товар
                    </a>
                </div>
            </If>
        </div>
    )
}
